module.exports = __webpack_public_path__ + "img/Ulta_case_study_2.5e593306.jpg";